import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from '../../common/Component';
import LoadingIndicator from '../../common/components/LoadingIndicator';
import ConfirmDocumentUnload from '../../common/components/ConfirmDocumentUnload';
import TextEditor from '../../common/components/TextEditor';
import listItems from '../../common/helpers/listItems';
import ItemList from '../../common/utils/ItemList';
import classList from '../../common/utils/classList';
import Avatar from '../../common/components/Avatar';
/**
 * The `ComposerBody` component handles the body, or the content, of the
 * composer. Subclasses should implement the `onsubmit` method and override
 * `headerTimes`.
 */
export default class ComposerBody extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "composer", void 0);
    _defineProperty(this, "jumpToPreview", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.composer = this.attrs.composer;

    // Let the composer state know to ask for confirmation under certain
    // circumstances, if the body supports / requires it and has a corresponding
    // confirmation question to ask.
    if (this.attrs.confirmExit) {
      this.composer.preventClosingWhen(() => this.hasChanges(), this.attrs.confirmExit);
    }
    this.composer.fields.content(this.attrs.originalContent || '');
  }
  view() {
    var _this$jumpToPreview;
    return m(ConfirmDocumentUnload, {
      when: this.hasChanges.bind(this)
    }, m("div", {
      className: classList('ComposerBody', this.attrs.className)
    }, m(Avatar, {
      user: this.attrs.user,
      className: "ComposerBody-avatar"
    }), m("div", {
      className: "ComposerBody-content"
    }, m("ul", {
      className: "ComposerBody-header"
    }, listItems(this.headerItems().toArray())), m("div", {
      className: "ComposerBody-editor"
    }, m(TextEditor, {
      submitLabel: this.attrs.submitLabel,
      placeholder: this.attrs.placeholder,
      disabled: this.loading || this.attrs.disabled,
      composer: this.composer,
      preview: (_this$jumpToPreview = this.jumpToPreview) == null ? void 0 : _this$jumpToPreview.bind(this),
      onchange: this.composer.fields.content,
      onsubmit: this.onsubmit.bind(this),
      value: this.composer.fields.content(),
      onTextEditorBuilt: this.attrs.onTextEditorBuilt
    }))), m(LoadingIndicator, {
      display: "unset",
      containerClassName: classList('ComposerBody-loading', this.loading && 'active'),
      size: "large"
    })));
  }

  /**
   * Check if there is any unsaved data.
   */
  hasChanges() {
    const content = this.composer.fields.content();
    return Boolean(content) && content !== this.attrs.originalContent;
  }

  /**
   * Build an item list for the composer's header.
   */
  headerItems() {
    return new ItemList();
  }

  /**
   * Handle the submit event of the text editor.
   */

  /**
   * Stop loading.
   */
  loaded() {
    this.loading = false;
    m.redraw();
  }
}
_defineProperty(ComposerBody, "focusOnSelector", null);
flarum.reg.add('core', 'forum/components/ComposerBody', ComposerBody);